import styled, { css } from 'styled-components';
import React from 'react';
import { slideIn } from 'styles/animation';
import { ApMenu, ApSelect, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	background-color: ${colors.white};
	animation-name: ${slideIn};
	animation-duration: 600ms;
	animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
`;

export const Container = styled.div`
	padding: 0 3%;
`;

export const CategoryInsightData = styled(({ children, ...props }) => (
	<table {...props}>
		<tbody>{children}</tbody>
	</table>
))``;
export const CategoryInsightRow = styled.tr``;
export const CategoryInsightLabel = styled.td`
	color: ${colors.grey500};
	font-size: 14px;
	line-height: 30px;
	text-transform: uppercase;
	font-weight: normal;
	padding: 1% 2% 1% 0;
	width: 100%;
`;
export const CategoryInsightValue = styled.td`
	color: ${colors.black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
`;

export const Select = styled(ApSelect)`
	width: 384px;
	min-width: 384px !important;
	${({ small }) =>
		small &&
		css`
			max-width: 175px !important;
			min-width: 175px !important;
		`};
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 15% 0;
`;

export const Actions = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	justify-content: ${props => (props.isTree ? 'space-between' : 'flex-end')};
`;

export const AbortPopup = styled.div`
	pointer-events: none;
`;

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;
export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 272px !important;
	min-width: 200px !important;
	max-height: calc(100% - 102px) !important;

	${({ isVirtualList }) =>
		isVirtualList &&
		css`
			height: 100%;
		`};
`;
export const MultiSelectWrapper = styled.span`
	> div {
		> div {
			border-radius: 0;
		}
	}
`;
export const CounterWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: -8px;
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	z-index: 2;
`;
